import { Result } from "antd";
import React from "react";

const FormError = ({msg}) => {
  return (
    <Result
      icon={
        <svg
          width="190"
          height="140"
          viewBox="0 0 190 140"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M147.359 71.2854C147.359 38.0095 120.383 11.0341 87.1075 11.0341C53.8316 11.0341 26.8562 38.0095 26.8562 71.2854C26.8562 88.0207 33.3643 105.494 47.5407 116.69C61.5483 127.754 83.5255 133.063 115.326 124.78C115.983 124.447 116.775 124.389 117.512 124.687L133.199 131.037L128.972 116.349C128.653 115.241 129.092 114.094 129.984 113.464C140.458 102.598 147.359 87.486 147.359 71.2854ZM134.479 116.396C145.42 104.699 152.638 88.6173 152.638 71.2854C152.638 35.0939 123.299 5.75482 87.1075 5.75482C50.916 5.75482 21.5769 35.0939 21.5769 71.2854C21.5769 89.2839 28.5718 108.436 44.2686 120.833C59.8822 133.165 83.6227 138.441 116.435 129.947L136.246 137.965L141.273 140L139.773 134.788L134.479 116.396Z"
            fill="#FF005C"
          />
          <path
            d="M51.9125 46.4535C51.9125 48.0711 52.2312 49.673 52.8502 51.1675C53.4693 52.662 54.3766 54.0199 55.5205 55.1638C56.6643 56.3077 58.0223 57.215 59.5168 57.8341C61.0113 58.4531 62.6131 58.7717 64.2308 58.7717C65.8484 58.7717 67.4502 58.4531 68.9448 57.8341C70.4393 57.215 71.7972 56.3077 72.9411 55.1638C74.0849 54.0199 74.9923 52.662 75.6113 51.1675C76.2304 49.673 76.549 48.0711 76.549 46.4535L72.8535 46.4535C72.8535 47.5858 72.6305 48.7071 72.1972 49.7533C71.7638 50.7994 71.1287 51.75 70.328 52.5507C69.5273 53.3514 68.5767 53.9866 67.5306 54.4199C66.4844 54.8532 65.3631 55.0763 64.2308 55.0763C63.0984 55.0763 61.9772 54.8532 60.931 54.4199C59.8848 53.9866 58.9343 53.3514 58.1336 52.5507C57.3329 51.75 56.6977 50.7994 56.2644 49.7533C55.831 48.7071 55.608 47.5858 55.608 46.4535L51.9125 46.4535Z"
            fill="#FF005C"
            stroke="#FF005C"
            stroke-width="1.69612"
          />
          <path
            d="M107.345 46.4535C107.345 48.0711 107.663 49.673 108.282 51.1675C108.901 52.662 109.809 54.0199 110.953 55.1638C112.096 56.3077 113.454 57.215 114.949 57.8341C116.443 58.4531 118.045 58.7717 119.663 58.7717C121.281 58.7717 122.882 58.4531 124.377 57.8341C125.871 57.215 127.229 56.3077 128.373 55.1638C129.517 54.0199 130.424 52.662 131.043 51.1675C131.662 49.673 131.981 48.0711 131.981 46.4535L128.286 46.4535C128.286 47.5858 128.063 48.7071 127.629 49.7533C127.196 50.7994 126.561 51.75 125.76 52.5507C124.959 53.3514 124.009 53.9866 122.963 54.4199C121.916 54.8532 120.795 55.0763 119.663 55.0763C118.53 55.0763 117.409 54.8532 116.363 54.4199C115.317 53.9866 114.366 53.3514 113.566 52.5507C112.765 51.75 112.13 50.7994 111.696 49.7533C111.263 48.7071 111.04 47.5858 111.04 46.4535L107.345 46.4535Z"
            fill="#FF005C"
            stroke="#FF005C"
            stroke-width="1.69612"
          />
          <path
            d="M77 98.3182C77 96.7006 77.3186 95.0988 77.9377 93.6043C78.5567 92.1097 79.4641 90.7518 80.6079 89.6079C81.7518 88.4641 83.1097 87.5567 84.6043 86.9377C86.0988 86.3186 87.7006 86 89.3182 86C90.9359 86 92.5377 86.3186 94.0322 86.9377C95.5267 87.5567 96.8847 88.4641 98.0285 89.6079C99.1724 90.7518 100.08 92.1097 100.699 93.6043C101.318 95.0988 101.636 96.7006 101.636 98.3182H97.941C97.941 97.1859 97.718 96.0646 97.2846 95.0185C96.8513 93.9723 96.2162 93.0217 95.4155 92.221C94.6148 91.4203 93.6642 90.7852 92.618 90.3518C91.5719 89.9185 90.4506 89.6955 89.3182 89.6955C88.1859 89.6955 87.0646 89.9185 86.0185 90.3518C84.9723 90.7852 84.0217 91.4203 83.221 92.221C82.4203 93.0217 81.7852 93.9723 81.3518 95.0185C80.9185 96.0646 80.6955 97.1859 80.6955 98.3182H77Z"
            fill="#FF005C"
            stroke="#FF005C"
            stroke-width="1.69612"
          />
          <rect
            y="63.0931"
            width="107.345"
            height="19.6505"
            rx="9.82526"
            fill="#FF005C"
            fill-opacity="0.13"
          />
          <rect
            x="38.1278"
            y="101.263"
            width="107.345"
            height="19.6505"
            rx="9.82526"
            fill="#FF005C"
            fill-opacity="0.13"
          />
          <rect
            x="72.3676"
            y="82.2828"
            width="107.345"
            height="19.6505"
            rx="9.82526"
            fill="#FF005C"
            fill-opacity="0.13"
          />
          <rect
            x="12"
            y="111"
            width="11"
            height="11"
            rx="3"
            stroke="#FF005C"
            stroke-width="3"
          />
          <rect
            x="167.688"
            y="111"
            width="9"
            height="10"
            rx="3"
            transform="rotate(27.955 167.688 111)"
            stroke="#FF005C"
            stroke-width="3"
          />
          <rect
            x="145.73"
            y="8.88365"
            width="9"
            height="10"
            rx="3"
            transform="rotate(-59.6558 145.73 8.88365)"
            stroke="#FF005C"
            stroke-width="3"
          />
          <path
            d="M24.5075 22.9189L20.972 19.3834L17.4365 22.9189C17.2489 23.1064 16.9946 23.2118 16.7294 23.2118C16.4641 23.2118 16.2098 23.1064 16.0223 22.9189C15.8347 22.7314 15.7294 22.477 15.7294 22.2118C15.7294 21.9466 15.8347 21.6922 16.0223 21.5047L19.5578 17.9692L16.0223 14.4336C15.8347 14.2461 15.7294 13.9917 15.7294 13.7265C15.7294 13.4613 15.8347 13.2069 16.0223 13.0194C16.2098 12.8319 16.4641 12.7265 16.7294 12.7265C16.9946 12.7265 17.2489 12.8319 17.4365 13.0194L20.972 16.5549L24.5075 13.0194C24.6951 12.8319 24.9494 12.7265 25.2146 12.7265C25.4799 12.7265 25.7342 12.8319 25.9217 13.0194C26.1093 13.2069 26.2146 13.4613 26.2146 13.7265C26.2146 13.9917 26.1093 14.2461 25.9217 14.4336L22.3862 17.9692L25.9217 21.5047C26.1093 21.6922 26.2146 21.9466 26.2146 22.2118C26.2146 22.477 26.1093 22.7314 25.9217 22.9189C25.7342 23.1064 25.4799 23.2118 25.2146 23.2118C24.9494 23.2118 24.6951 23.1064 24.5075 22.9189Z"
            fill="#FF005C"
          />
          <path
            d="M183.435 67.8492L179.899 64.3137L176.364 67.8492C176.176 68.0368 175.922 68.1421 175.657 68.1421C175.392 68.1421 175.137 68.0368 174.95 67.8492C174.762 67.6617 174.657 67.4074 174.657 67.1421C174.657 66.8769 174.762 66.6226 174.95 66.435L178.485 62.8995L174.95 59.364C174.762 59.1764 174.657 58.9221 174.657 58.6569C174.657 58.3916 174.762 58.1373 174.95 57.9497C175.137 57.7622 175.392 57.6569 175.657 57.6569C175.922 57.6569 176.176 57.7622 176.364 57.9497L179.899 61.4853L183.435 57.9497C183.623 57.7622 183.877 57.6569 184.142 57.6569C184.407 57.6569 184.662 57.7622 184.849 57.9497C185.037 58.1373 185.142 58.3916 185.142 58.6569C185.142 58.9221 185.037 59.1764 184.849 59.364L181.314 62.8995L184.849 66.435C185.037 66.6226 185.142 66.8769 185.142 67.1421C185.142 67.4074 185.037 67.6617 184.849 67.8492C184.662 68.0368 184.407 68.1421 184.142 68.1421C183.877 68.1421 183.623 68.0368 183.435 67.8492Z"
            fill="#FF005C"
          />
        </svg>
      }
      className="form-success-create-cv"
      subTitle={msg}
    />
  );
};

export default FormError;
